import AMLFlame from './AMLFlame';

export default AMLFlame;
